// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1tRUl","label":"Labeled_label__3bnLG","divider":"Labeled_divider__3bxwr"};